import { TweenLite, Power0 } from 'gsap'

export default {
  init () {
    TweenLite.from(
      $('.press-entry-list'),
      0.6,
      {
        backgroundColor: '#ffffff',
        ease: Power0.easeNone,
      }
    )

    $('body').on('mouseenter', '.press-entry-listed', function (event) {
      if (typeof $(this).data('animateInDone') === 'undefined' || $(this).data('animateInDone') !== true) {
        return
      }
      $(this).data('timelineHover').play()
    })

    $('body').on('mouseleave', '.press-entry-listed', function (event) {
      $(this).data('timelineHover').reverse()
    })
  },
  finalize () {
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchivePressEntry.js